module.exports = __webpack_public_path__ + "img/icon-atlassian.1fe727cd.png";